import React, { useState } from "react"
import { closeIncentiveListModal, IncentiveListAction, requestAggregateByCsv } from "../../actions/incentiveList"
import { BaseModal } from "../../components/BaseModal"
import { Box, Button, Center, Group, Loader, ScrollArea, Stack, Text } from "@mantine/core"
import { CsvUploadTab } from "../../components/cv/incentive/CsvUploadTab"
import { State } from "../../reducers"
import { ThunkDispatch } from "redux-thunk"
import { connect } from "react-redux"

interface OwnProps {
  clientId: number
}

interface StateProps {
  open: boolean
  loading: boolean
  error: string | null
}

interface DispatchProps {
  closeIncentiveListModal: typeof closeIncentiveListModal
  requestAggregateByCsv: (clientId: number, file: File) => Promise<void>
}

type Props = OwnProps & StateProps & DispatchProps

// 特典付与代行リスト生成モーダル本体
const IncentiveListModalComponent: React.FC<Props> = ({
  clientId,
  open,
  loading,
  error,
  closeIncentiveListModal,
  requestAggregateByCsv,
}) => {
  const [file, setFile] = useState<File | null>(null)

  const handleClose = () => {
    closeIncentiveListModal()
  }

  const handleGenerate = async () => {
    if (!file) return
    await requestAggregateByCsv(clientId, file)
  }

  return (
    <BaseModal
      opened={open}
      onClose={handleClose}
      title="特典付与リスト生成"
      width={600}

      // 閉じ切ってから選択中ファイルを捨てる（閉じるアニメーション中の表示崩れを避ける）
      onExited={() => setFile(null)}
    >
      <ScrollArea style={{ flex: 1, minHeight: 0 }} px={24}>
        <Stack gap="md" p={16}>
          <CsvUploadTab file={file} onFileChange={setFile} disabled={loading} />

          {loading && (
            <Center>
              <Loader />
            </Center>
          )}
          {error && (
            <Text c="red" fz={13}>
              {error}
            </Text>
          )}
        </Stack>
      </ScrollArea>

      <Box
        p="md"
        style={{
          borderTop: '1px solid #0000001A',
          backgroundColor: '#fff',
          flexShrink: 0,
        }}
      >
        <Group justify="flex-end" gap={8}>
          <Button
            variant="filled"
            radius="xl"
            disabled={!file || loading}
            onClick={handleGenerate}
          >
            リスト生成
          </Button>
        </Group>
      </Box>
    </BaseModal>
  )
}

const mapStateToProps = (state: State): StateProps => ({
  open: state.incentiveList.modalOpen,
  loading: state.incentiveList.loading,
  error: state.incentiveList.error,
})

const mapDispatchToProps = (
  dispatch: ThunkDispatch<null, null, IncentiveListAction>,
): DispatchProps => ({
  closeIncentiveListModal: () => dispatch(closeIncentiveListModal()),
  requestAggregateByCsv: (clientId, file) => dispatch(requestAggregateByCsv(clientId, file)),
})

export const IncentiveListModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(IncentiveListModalComponent as any) as any as React.ComponentType<OwnProps>
